<style>
</style>
<template>
  <div id="page--contacts">
    <div v-if="hasInstitution">
      <v-row dense cols="12" sm="7" xs="12">
        <v-col>
          <span class="subtitle-2">{{ $t('Najdete nás') }}</span>
          <div>{{ this.institution.institutionName }}</div>
          <div v-if="this.institution.contactAddress">{{ this.institution.contactAddress.shortFriendlyAddress }}</div>
        </v-col>
        <v-col mt-3>
          <span class="subtitle-2">{{ $t('Naše lokality') }}</span>
          <v-row dense>
            <v-col cols="12" v-for="locality in this.institution.localities" :key="locality.localityId">
              <!-- <a class="social" :href="contact.url" :alt="locality.localityName"> -->
              <!-- <i aria-hidden="true" class="fa fa-map-marker"></i> -->
              <div>{{ locality.localityName }}</div>
              <!-- <v-col v-for="item in contact.items" :key="item">
                <small>{{ item }}</small>
              </v-col> -->
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-col cols="12">
        <span class="subtitle-2">{{ $t('Kontakty') }}</span>
        <div v-if="instHomepage">
          <v-icon size="18px" class="mr-3">link</v-icon>
          <a :href="instHomepage" target="_blank">{{ instHomepage }}</a>
        </div>
        <div v-if="this.institution.eMail">
          <v-icon size="18px" class="mr-3">email</v-icon>
          <a :href="`mailto:${this.institution.eMail}`">{{ this.institution.eMail }}</a>
        </div>
        <div v-if="this.institution.phoneNo">
          <v-icon size="18px" class="mr-3">phone</v-icon>
          {{ this.institution.phoneNo }}
        </div>
        <div v-if="this.institution.faxNo">
          <v-icon size="18px" class="mr-3">print</v-icon>
          {{ this.institution.faxNo }}
        </div>
        <v-row dense v-if="this.institution.ico">
          <v-col cols="1">
            <span>{{ $t('IČ') }}</span>
          </v-col>
          <v-col cols="11">
            <span>{{ this.institution.ico }}</span>
          </v-col>
        </v-row>
        <v-row dense v-if="this.institution.dic">
          <v-col cols="1">
            <span>{{ $t('DIČ') }}</span>
          </v-col>
          <v-col cols="11">
            <span>{{ this.institution.dic }}</span>
          </v-col>
        </v-row>
      </v-col>
    </div>
  </div>
</template>
<script>
import CustomerMixin from '@/mixins/customer-mixin.js'
import InstitutionMixin from '@gravela/vue-component-library/src/mixins/institution-mixin.js'
import TransformMixin from '@gravela/vue-component-library/src/mixins/transform-mixin.js'

export default {
  data() {
    return {
      currentDate: new Date(),
      socials: [{
        'name': 'facebook',
        'info': 'info_facebook',
        'icon': 'fa-facebook'
      }, {
        'name': 'twitter',
        'info': 'info_twitter',
        'icon': 'fa-twitter'
      }, {
        'name': 'google_plus',
        'info': 'info_google_plus',
        'icon': 'fa-google-plus'
      }, {
        'name': 'linkedin',
        'info': 'info_linkedin',
        'icon': 'fa-linkedin'
      }, {
        'name': 'instagram',
        'info': 'info_instagram',
        'icon': 'fa-instagram'
      }, {
        'name': 'pinterest',
        'info': 'info_pinterest',
        'icon': 'fa-pinterest'
      }]
    }
  },
  mixins: [CustomerMixin, InstitutionMixin, TransformMixin]
}
</script>
